import { always } from 'ramda';
import { handleActions } from 'redux-actions';

import { EMPTY_VALUES } from 'constants/general';

import * as types from './actionTypes';

export const initialState = {
	infoDetail: {},
	history: EMPTY_VALUES.ARRAY,
};

const setHistory = (state, action) => {
	return {
		...state,
		history: action.payload.history,
	};
};

const setDetails = (state, action) => {
	return {
		...state,
		infoDetail: action.payload.details,
	};
};

const addNote = (state, action) => {
	const newComment = {
		comment: action.payload.comment,
		dateCreated: new Date().toISOString(),
		userCreatedFirstName: action.payload.firstName,
		userCreatedSurname: action.payload.surname,
	};

	return {
		...state,
		infoDetail: {
			...state.infoDetail,
			comments: [newComment, ...state.infoDetail.comments],
		},
	};
};

const leadDetailReducer = {
	[types.SET_LEAD_DETAILS]: setDetails,
	[types.SET_LEAD_HISTORY]: setHistory,
	[types.ADD_LEAD_NOTE]: addNote,
	[types.RESET_REDUCER]: always(initialState),
};

export default handleActions(leadDetailReducer, initialState);
